import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import authorizeGetRequest from '../api/authorizeGetRequest';
import authorizeDeleteRequest from '../api/authorizeDeleteRequest';
import authorizePostMultipart from '../api/authorizePostMultipart';
import authorizePatchMultipart from '../api/authorizePatchMultipart';
import TitleNParagraph from '../components/TitleNParagraph';
import rhf1 from '../assets/rhf1.jpg'
import rhf2 from '../assets/rhf2.jpg'
import rhf3 from '../assets/rhf3.jpg'
import carousel1 from '../assets/carousel-1.jpg'
import AboutModal from '../components/AboutModal';
import HomeModal from '../components/HomeModal';

const WebsiteContent = () => {
  const { id } = useParams();
  const [showForm, setShowForm] = useState(false)
  const [loading, setLoading] = useState(true);
  const [feedData, setFeedData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('')
  const [pagBack, setPagBack] = useState(false)
  const [pagForward, setPagForward] = useState(false)
  const [editFeed, setEditFeed] = useState(false)
  const [editFeedId, setEditFeedId] = useState()
  const [img, setImg] = useState('')
  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')
  const [category, setCategory] = useState('')
  const [programContent, setProgramContent] = useState([
    { id: 0, title: '', titleVisible: true, paragraph: '' }
  ])
  const [status, setStatus] = useState(1)
  const [oldImgs, setOldImgs] = useState('')
  const [programsFeed, setProgramsFeed] = useState([])
  const [imgPreview, setImgPreview] = useState('https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y');
  const [imgPreviewCampaign, setImgPreviewCampaign] = useState([])
  const [imgErr, setimgErr] = useState('')
  const [aboutModalScreen, setAboutModalScreen] = useState('')
  const [aboutModalData, setAboutModalData] = useState('')
  const [aboutFeed, setAboutFeed] = useState([])
  const [aboutImg, setAboutImg] = useState('')
  const [homeFeed, setHomeFeed] = useState([])
  const [bannerContent, setBannerContent] = useState([
    { id: 0, img: '', title: '', caption: '' }
  ])

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      setEditFeedId()
      setAboutFeed([])
      setProgramsFeed([])
      setimgErr('')
      setImgPreviewCampaign([])
      setImgPreview('https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y');
      setOldImgs('')
      setStatus(1)
      setProgramContent([
        { id: 0, title: '', titleVisible: true, paragraph: '' }
      ])
      setTitle('')
      setCategory('')
      setSubTitle('')
      setImg('')
      setEditFeed(false)
      setPagBack(false)
      setPagForward(false)
      setFeedData([])
      setShowForm(false)
      setErrorMessage('')
      // console.log('inside usE', id)
      // setShowForm(false);
      if (id === 'campaigns') {
        await authorizeGetRequest('campaign/0')
          .then((response) => {
            // console.log('campaigns', response.campaigns);
            if (response.campaigns !== 0) {
              setFeedData(response.campaigns)
            } else {
              setFeedData([])
            }
          })
          .catch((err) => {
            setFeedData([])
            console.log('campaigns error', err);
          });
      } else if (id === 'home') {
        // setTitle('Mobile App Feed / Post Types')
        await authorizeGetRequest('pageContent/home')
          .then((response) => {
            console.log('home.pageContent', response.pageContent)
            if (response.pageContent !== 0) {
              setHomeFeed(response.pageContent)
              // setAboutImg(response.pageContent[0].content)
            } else {
              setHomeFeed([])
            }
          })
          .catch((err) => {
            setHomeFeed([])
            console.log('response.pageContent error', err);
          });
      } else if (id === 'about') {
        // setTitle('Mobile App Feed / Post Types')
        await authorizeGetRequest('pageContent/about')
          .then((response) => {
            // console.log('response.pageContent', response.pageContent, JSON.parse(response.pageContent[1].content))
            if (response.pageContent !== 0) {
              setAboutFeed(JSON.parse(response.pageContent[1].content))
              setAboutImg(response.pageContent[0].content)
            } else {
              setAboutFeed([])
            }
          })
          .catch((err) => {
            setAboutFeed([])
            console.log('response.pageContent error', err);
          });
      } else if (id === 'hellen') {
        // setTitle('Mobile App Feed / Post Types')
      } else if (id === 'programs') {
        await authorizeGetRequest('program/0')
          .then((response) => {
            if (response.programAreas !== 0) {
              setProgramsFeed(response.programAreas)
            } else {
              setProgramsFeed([])
            }
          })
          .catch((err) => {
            setProgramsFeed([])
            console.log('programAreas error', err);
          });
      }
      setLoading(false)
      // console.log('token', localStorage.getItem('RHFAdmintoken'))
    }
    getData();
  }, [id])

  const handleImgChange = e => {
    console.log('files', e.target.files.length)
    setimgErr('')
    if (e.target.files.length > 6) {
      const rem = e.target.files.length - 6
      setimgErr(`Only the first 6 images will be uploaded, the remaining ${rem} will be discarded`)
    }
    let image = new Image();
    image.src = URL.createObjectURL(e.target.files[0]);
    image.onload = async () => {
      const imgss = [], imgup = []
      for (let index = 0; index < 6; index++) {
        if (index < e.target.files.length) {
          imgss.push(URL.createObjectURL(e.target.files[index]));
          imgup.push(e.target.files[index]);
        }
      }
      setImg(imgup);
      // console.log('imgs', imgss)
      setImgPreviewCampaign(imgss);
    };
  }
  const onChangeProgParagraph = async (id, item) => {
    let cont = programContent
    cont[id].paragraph = item
    await setProgramContent(cont)
  }
  const onChangeParagraphTitle = async (id, item) => {
    let cont = programContent
    cont[id].title = item
    await setProgramContent(cont)
  }
  const onSubmitFeed = async (e) => {
    e.preventDefault();
    setLoading(true)
    setErrorMessage('')
    const formData = new FormData();
    if (img) {
      img.forEach((item, index) => {
        const indx = index + 1
        formData.append(`img${indx}`, item);
      });
    }
    formData.append('category', category);
    formData.append('title', title);
    formData.append('subtitle', subTitle);
    formData.append('content', JSON.stringify(programContent));
    if (editFeed) {
      if (img) {
        formData.append('oldImgs', oldImgs)
      }
      formData.append('status', Number(status))
      await authorizePatchMultipart(`campaign/${editFeedId}`, formData)
        .then((response) => {
          setShowForm(false);
          setFeedData(response.campaigns)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'success',
            titleText: response.message,
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((err) => {
          // console.log('mobileAppFeed error', err);
          setErrorMessage(err.message)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'error',
            titleText: err.message,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    } else {
      await authorizePostMultipart('campaign', formData)
        .then((response) => {
          setShowForm(false);
          setFeedData(response.campaigns)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'success',
            titleText: response.message,
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((err) => {
          // console.log('mobileAppFeed error', err);
          setErrorMessage(err.message)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'error',
            titleText: err.message,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    }
    setLoading(false)
  }
  const onDelete = async (id) => {
    setLoading(true)
    await authorizeDeleteRequest(`campaign/${id}`)
      .then((response) => {
        setFeedData(response.campaigns)
        Swal.fire({
          position: 'top-end',
          toast: true,
          width: 600,
          // background: '#F47E52',
          icon: 'success',
          titleText: response.message,
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .catch((err) => {
        // console.log('mobileAppFeed error', err);
        Swal.fire({
          position: 'top-end',
          toast: true,
          width: 600,
          // background: '#F47E52',
          icon: 'error',
          titleText: err.message,
          showConfirmButton: false,
          timer: 2500,
        });
      });
    setLoading(false);
  }
  const onDeleteProg = async (id) => {
    setLoading(true)
    await authorizeDeleteRequest(`program/${id}`)
      .then((response) => {
        setProgramsFeed(response.programAreas)
        Swal.fire({
          position: 'top-end',
          toast: true,
          width: 600,
          // background: '#F47E52',
          icon: 'success',
          titleText: response.message,
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .catch((err) => {
        // console.log('mobileAppFeed error', err);
        Swal.fire({
          position: 'top-end',
          toast: true,
          width: 600,
          // background: '#F47E52',
          icon: 'error',
          titleText: err.message,
          showConfirmButton: false,
          timer: 2500,
        });
      });
    setLoading(false);
  }
  const handleProgParagraphAdd = async (id) => {
    await setProgramContent([...programContent, { id: id, title: '', titleVisible: true, paragraph: '' }])
    // console.log('add id', id, content)
  }
  const handleParagraphTitleDel = async (id) => {
    let cont = programContent
    cont[id].title = ''
    cont[id].titleVisible = false
    await setProgramContent(cont)
  }
  const handleProgParagraphDelete = async (id) => {
    let cont = programContent
    const indexOfObject = cont.findIndex(object => {
      return object.id === id;
    });
    await cont.splice(indexOfObject, 1);
    setProgramContent(cont)
  }
  const handleImgProgChange = e => {
    let image = new Image();
    image.src = URL.createObjectURL(e.target.files[0]);
    image.onload = async () => {
      setImg(e.target.files[0]);
      setImgPreview(URL.createObjectURL(e.target.files[0]));
    };
  }
  const onSubmitProgram = async (e) => {
    e.preventDefault();
    setLoading(true)
    setErrorMessage('')
    const formData = new FormData();
    if (img) {
      formData.append('img', img);
    }
    formData.append('title', title);
    formData.append('subtitle', subTitle);
    formData.append('content', JSON.stringify(programContent));
    if (editFeed) {
      if (img) {
        formData.append('oldImg', oldImgs)
      }
      formData.append('status', Number(status))
      await authorizePatchMultipart(`program/${editFeedId}`, formData)
        .then((response) => {
          setShowForm(false);
          setProgramsFeed(response.programAreas)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'success',
            titleText: response.message,
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((err) => {
          // console.log('mobileAppFeed error', err);
          setErrorMessage(err.message)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'error',
            titleText: err.message,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    } else {
      await authorizePostMultipart('program', formData)
        .then((response) => {
          setShowForm(false);
          setProgramsFeed(response.programAreas)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'success',
            titleText: response.message,
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((err) => {
          // console.log('mobileAppFeed error', err);
          setErrorMessage(err.message)
          Swal.fire({
            position: 'top-end',
            toast: true,
            width: 600,
            // background: '#F47E52',
            icon: 'error',
            titleText: err.message,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    }
    setLoading(false)
  }
  const setAboutData = async (dt) => {
    // console.log('inside about data', dt)
    setAboutFeed(JSON.parse(dt[1].content))
    setAboutImg(dt[0].content)
  }
  // home content start
  const setHomeData = async (dt) => {
    // console.log('inside home data', dt)
    setHomeFeed(dt)
  }
  const handleBannerDataAdd = async (id) => {
    await setBannerContent([...bannerContent, { id: id, img: '', title: '', caption: '' }])
    // console.log('add id', id, content)
  }
  const handleBannerDataDelete = async (id) => {
    let cont = bannerContent
    const indexOfObject = cont.findIndex(object => {
      return object.id === id;
    });
    await cont.splice(indexOfObject, 1);
    setBannerContent(cont)
  }
  const handleBannerImgChange = async (id, item) => {
    // console.log('img', item)
    let image = new Image();
    image.src = URL.createObjectURL(item[0]);
    image.onload = async () => {
      let cont = bannerContent
      cont[id].img = item[0]
      await setBannerContent(cont)
      // setImgPreview(URL.createObjectURL(item[0]));
    };
  }
  const onChangeCaption = async (id, item) => {
    let cont = bannerContent
    cont[id].caption = item
    await setBannerContent(cont)
  }
  const onChangeBannerTitle = async (id, item) => {
    let cont = bannerContent
    cont[id].title = item
    await setBannerContent(cont)
  }
  // home content end

  return (
    <div className="content">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              {loading ? (
                <>
                  <div className="loader m-5 text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {id === 'programs' && (
                    <>
                      {showForm ? (
                        <div className='ml-5'>
                          <form method='post' className='p-3' onSubmit={onSubmitProgram}>
                            <h5 className="title">Add Program Area</h5>
                            <div className='col-lg-8 col-sm-11'>
                              {errorMessage && <p className='text-danger text-center'>{errorMessage}</p>}
                              <div className='form-group'>
                                <label htmlFor='subject'>Title</label>
                                <input
                                  name='title'
                                  value={title}
                                  onChange={(e) => setTitle(e.target.value)}
                                  required
                                  className='form-control form-control-lg'
                                />
                              </div>
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              <div className='form-group'>
                                <label htmlFor='subject'>Short summary</label>
                                <input
                                  name='subtitle'
                                  value={subTitle}
                                  onChange={(e) => setSubTitle(e.target.value)}
                                  required
                                  className='form-control form-control-lg'
                                />
                              </div>
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              <div className='form-group mt-4 mb-4'>
                                <label className='mr-2' htmlFor='Image'>Image</label>
                                <input
                                  type="file"
                                  name='img'
                                  // value={img}
                                  accept="image/*"
                                  multiple={true}
                                  onChange={handleImgProgChange}
                                  required={editFeed ? false : true}
                                // className='form-control form-control-lg'
                                />
                                <img src={imgPreview} width={150} height={150} />
                              </div>
                            </div>
                            {editFeed && (
                              <div className='col-lg-8 col-sm-11'>
                                <div className='form-group'>
                                  <label htmlFor='subject'>Status</label>
                                  <select value={status} onChange={(e) => setStatus(e.target.value)} className="custom-select" id="inputGroupSelect01">
                                    <option>Choose...</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                  </select>
                                </div>
                              </div>
                            )}
                            <TitleNParagraph paragraphs={programContent} onChangeParagraphTitle={onChangeParagraphTitle} handleParagraphTitleDel={handleParagraphTitleDel} handleParagraphAdd={handleProgParagraphAdd} handleParagraphDelete={handleProgParagraphDelete} onChangeParagraph={onChangeProgParagraph} />

                            <div className='col-lg-8 col-sm-11'>
                              {errorMessage && <p className='text-danger text-center'>{errorMessage}</p>}
                              <div className='form-group'>
                                <button
                                  type='submit'
                                  className="btn btn-primary">{editFeed ? 'Edit Post' : 'Submit'}</button>
                              </div>
                              <div className='form-group'>
                                <button
                                  onClick={() => setShowForm(false)}
                                  className="btn btn-danger">Cancel</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      ) : (
                        <>
                          <div className="card-header">
                            <button onClick={() => {
                              setTitle('')
                              setSubTitle('')
                              setProgramContent([{ id: 0, title: '', titleVisible: true, paragraph: '' }])
                              setStatus('')
                              setEditFeedId('')
                              setImg('')
                              setImgPreview('https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y')
                              setOldImgs('')
                              setEditFeed(false)
                              setShowForm(true)
                            }} className="btn btn-primary btn-icon btn-round btn-lg">
                              <i className="fas fa-plus"></i>
                            </button>
                            <h5 className="title mt-3">Program Areas</h5>
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table">
                                <thead className="text-primary">
                                  <th>#</th>
                                  <th>Title</th>
                                  <th>SubTitle</th>
                                  <th>Status</th>
                                  <th colSpan={2}></th>
                                </thead>
                                <tbody>
                                  {programsFeed.length >= 1 ? (
                                    <>
                                      {programsFeed.map((item, index) => {
                                        // const imgs = JSON.parse(item.imgs)
                                        return (
                                          <tr key={index}>
                                            <td className="text-left">
                                              <img src={item.img} style={{ minWidth: 100, minHeight: 100, maxWidth: 100, maxHeight: 100 }} />
                                            </td>
                                            <td className="text-left">
                                              {item.title}
                                            </td>
                                            <td className="text-left">
                                              {item.subtitle}
                                            </td>
                                            <td className="text-left">
                                              {Number(item.status) === 1 ? 'Active' : 'In-active'}
                                            </td>
                                            <td className="text-left">
                                              <button data-toggle="modal" data-target="#exampleModal" onClick={() => {
                                                setTitle(item.title)
                                                setSubTitle(item.subtitle)
                                                setProgramContent(JSON.parse(item.content))
                                                setStatus(item.status)
                                                setEditFeedId(item.id)
                                                setImg('')
                                                setImgPreview(item.img)
                                                setOldImgs(item.img)
                                                setEditFeed(true)
                                                setShowForm(true)
                                              }} className="btn btn-primary btn-circle">
                                                <i className="fas fa-edit"></i>
                                              </button>
                                            </td>
                                            <td className="text-left">
                                              <button onClick={() => onDeleteProg(item.id)} className="btn btn-danger btn-circle">
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td className='text-center' colSpan={5}>
                                        Program areas will appear here
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex">
                              {pagBack && (
                                <button onClick={() => {
                                  if (feedData.length > 15) {
                                    const dt = feedData[feedData.length - 1]
                                    console.log('element', dt)
                                  } else {
                                    setPagBack(false);
                                  }
                                }} className="btn btn-primary btn-icon btn-round mr-2">
                                  <i className="fas fa-chevron-left"></i>
                                </button>
                              )}
                              {pagForward && (
                                <button onClick={() => {
                                  if (feedData.length > 15) {

                                  } else {
                                    setPagForward(false);
                                  }
                                }} className="btn btn-primary btn-icon btn-round">
                                  <i className="fas fa-chevron-right"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {id === 'campaigns' && (
                    <>
                      {showForm ? (
                        <div className='ml-1'>
                          <form method='post' className='p-3' onSubmit={onSubmitFeed}>
                            <h5 className="title">Add Campaign</h5>
                            <div className='col-lg-8 col-sm-11'>
                              {errorMessage && <p className='text-danger text-center'>{errorMessage}</p>}
                              <div className='form-group'>
                                <label htmlFor='subject'>Category</label>
                                <input
                                  name='category'
                                  value={category}
                                  onChange={(e) => setCategory(e.target.value)}
                                  required
                                  placeholder='eg education, healthy living'
                                  className='form-control form-control-lg'
                                />
                              </div>
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              <div className='form-group'>
                                <label htmlFor='subject'>Title</label>
                                <input
                                  name='title'
                                  value={title}
                                  onChange={(e) => setTitle(e.target.value)}
                                  required
                                  className='form-control form-control-lg'
                                />
                              </div>
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              <div className='form-group'>
                                <label htmlFor='subject'>Short Description</label>
                                <input
                                  name='subtitle'
                                  value={subTitle}
                                  onChange={(e) => setSubTitle(e.target.value)}
                                  required
                                  className='form-control form-control-lg'
                                />
                              </div>
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              <div className='form-group mt-4 mb-4'>
                                <label className='mr-2' htmlFor='Image'>Images(6 max)</label>
                                <label className='mr-2 text-danger' htmlFor='Image'>{imgErr}</label>
                                <input
                                  type="file"
                                  name='img'
                                  accept="image/*"
                                  multiple={true}
                                  onChange={handleImgChange}
                                  required={editFeed ? false : true}
                                // className='form-control form-control-lg'
                                />
                                {imgPreviewCampaign.length >= 1 && (
                                  <>
                                    {imgPreviewCampaign.map((item, index) => <img src={item} key={index} alt="img" className="mr-2 mt-2" width={150} height={150} />)}
                                  </>
                                )}

                              </div>
                            </div>
                            {editFeed && (
                              <div className='col-lg-8 col-sm-11'>
                                <div className='form-group'>
                                  <label htmlFor='subject'>Status</label>
                                  <select value={status} onChange={(e) => setStatus(e.target.value)} className="custom-select" id="inputGroupSelect01">
                                    <option>Choose...</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                  </select>
                                </div>
                              </div>
                            )}
                            <div className='col-lg-8 col-sm-11 p-0'>
                              <TitleNParagraph paragraphs={programContent} onChangeParagraphTitle={onChangeParagraphTitle} handleParagraphTitleDel={handleParagraphTitleDel} handleParagraphAdd={handleProgParagraphAdd} handleParagraphDelete={handleProgParagraphDelete} onChangeParagraph={onChangeProgParagraph} />
                            </div>
                            <div className='col-lg-8 col-sm-11'>
                              {errorMessage && <p className='text-danger text-center'>{errorMessage}</p>}
                              <div className='form-group'>
                                <button
                                  type='submit'
                                  className="btn btn-primary">{editFeed ? 'Edit Post' : 'Submit'}</button>
                              </div>
                              <div className='form-group'>
                                <button
                                  onClick={() => setShowForm(false)}
                                  className="btn btn-danger">Cancel</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      ) : (
                        <>
                          <div className="card-header">
                            <button onClick={() => {
                              setTitle('')
                              setCategory('')
                              setSubTitle('')
                              setProgramContent([{ id: 0, title: '', titleVisible: true, paragraph: '' }])
                              setStatus('')
                              setEditFeedId('')
                              setImgPreview('https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y')
                              setOldImgs('')
                              setImgPreviewCampaign([])
                              setEditFeed(false)
                              setShowForm(true)
                            }} className="btn btn-primary btn-icon btn-round btn-lg">
                              <i className="fas fa-plus"></i>
                            </button>
                            <h5 className="title mt-3">Campaigns</h5>
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table">
                                <thead className="text-primary">
                                  <th>#</th>
                                  <th>Title</th>
                                  <th>Category</th>
                                  <th>Status</th>
                                  <th colSpan={2}></th>
                                </thead>
                                <tbody>
                                  {feedData.length >= 1 ? (
                                    <>
                                      {feedData.map((item, index) => {
                                        const imgs = JSON.parse(item.imgs)
                                        // console.log('campimgs', imgs)
                                        return (
                                          <tr key={index}>
                                            <td className="text-left">
                                              <img src={imgs.img1} style={{ minWidth: 100, maxWidth: 100 }} />
                                            </td>
                                            <td className="text-left">
                                              {item.title}
                                            </td>
                                            <td className="text-left">
                                              {item.category}
                                            </td>
                                            <td className="text-left">
                                              {Number(item.status) === 1 ? 'Active' : 'In-active'}
                                            </td>
                                            <td className="text-left">
                                              <button data-toggle="modal" data-target="#exampleModal" onClick={() => {
                                                setTitle(item.title)
                                                setCategory(item.category)
                                                setSubTitle(item.subtitle)
                                                setProgramContent(JSON.parse(item.content))
                                                setStatus(item.status)
                                                setEditFeedId(item.id)
                                                setImgPreviewCampaign([imgs.img1, imgs.img2, imgs.img3, imgs.img4, imgs.img5, imgs.img6])
                                                setOldImgs(item.imgs)
                                                setEditFeed(true)
                                                setShowForm(true)
                                              }} className="btn btn-primary btn-circle">
                                                <i className="fas fa-edit"></i>
                                              </button>
                                            </td>
                                            <td className="text-left">
                                              <button onClick={() => onDelete(item.id)} className="btn btn-danger btn-circle">
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td className='text-center' colSpan={5}>
                                        The feed you post will appear here
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex">
                              {pagBack && (
                                <button onClick={() => {
                                  if (feedData.length > 15) {
                                    const dt = feedData[feedData.length - 1]
                                    console.log('element', dt)
                                  } else {
                                    setPagBack(false);
                                  }
                                }} className="btn btn-primary btn-icon btn-round mr-2">
                                  <i className="fas fa-chevron-left"></i>
                                </button>
                              )}
                              {pagForward && (
                                <button onClick={() => {
                                  if (feedData.length > 15) {

                                  } else {
                                    setPagForward(false);
                                  }
                                }} className="btn btn-primary btn-icon btn-round">
                                  <i className="fas fa-chevron-right"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {id === 'home' && (
                    <>
                      <h4 className="display-6 mb-5">Edit Home page content</h4>
                        <button onClick={() => {
                          setAboutModalScreen('banners')
                          // setAboutModalData(aboutFeed)
                          if (homeFeed[0]) {
                            setBannerContent(JSON.parse(homeFeed[0]?.content))
                          }
                        }} data-toggle="modal" data-target="#homeModal" style={{ backgroundColor: "#832a84" }}  className="d-inline-block rounded  mt-1 text-white border-0 py-1 px-3 mb-3">Edit Banners</button>
                      
                      <div className="col-lg-8 wow fadeIn" data-wow-delay="0.1s">
                          {homeFeed[0] && (
                            <>
                              {JSON.parse(homeFeed[0]?.content).map((item, index) => {
                                // console.log('item', item)
                                return (
                                <>

                                <div className='border rounded p-3 mb-3  '>
                                  <img className="mb-2" height={150} src={item.img} alt="img" />
                                    <p>{`TITLE: ${item.title}`}</p>
                                    <p>{`CAPTION: ${item.caption}`}</p>

                                </div>
                                  
                                </>
                                )
                              })}
                            </>
                          )}
                      </div>
                        <button onClick={async () => {
                          setAboutModalScreen('aboutus')
                          // setAboutModalData(aboutFeed)
                          console.log('homefeed1', JSON.parse(homeFeed[1]?.content))
                          if (homeFeed[1]) {
                            await setBannerContent(JSON.parse(homeFeed[1]?.content))
                          } else {
                            const dt = {
                              img: "",
                              title: "",
                              founderCaption: "",
                              description: "",
                            }
                            await setBannerContent(dt)
                          }
                        }} data-toggle="modal" data-target="#homeModal" style={{ backgroundColor: "#832a84" }} className="d-inline-block rounded   mt-1 text-white border-0 py-1 px-3 mb-3">Edit About Us section</button>
                        <div className='border rounded p-3 mb-3'>
                          <div className="row g-5">
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                              <div className="position-relative overflow-hidden h-100" style={{ minHeight: 400 }}>
                                  <img className="position-absolute w-100 h-100 pt-5 pe-2" src={JSON.parse(homeFeed[1]?.content).img} alt="" style={{ objectFit: 'cover' }} />
                              </div>
                            </div>
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                              <div className="">
                                  <h1 className="display-6 mb-5">{JSON.parse(homeFeed[1]?.content).title}</h1>
                                <div className="bg-light border-bottom border-5 border-primary rounded p-4 mb-4">
                                    <p className="text-dark mb-2">{JSON.parse(homeFeed[1]?.content).founderCaption}</p>
                                  <span className="text-primary">Hellen, Founder</span>
                                </div>
                                  <p className="mb-5">{JSON.parse(homeFeed[1]?.content).description}</p>

                              </div>
                            </div>
                          </div>
                        </div>

                        <button onClick={async () => {
                          setAboutModalScreen('programareas')
                          setBannerContent(homeFeed[2])
                        }} data-toggle="modal" data-target="#homeModal" style={{ backgroundColor: "#832a84" }} className="d-inline-block rounded mt-3 text-white border-0 py-1 px-3 mb-3">Edit Program areas section</button>
                        
                        <div className='border rounded p-3 mb-3'>
                          <div className="row g-4 justify-content-center">
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                              <div className="service-item bg-white text-center h-100 p-4 p-xl-5">
                                  <img className="img-fluid mb-4" src={homeFeed[2].pga1.img} alt="" style={{ objectFit: 'cover', maxHeight: 120, minHeight: 120 }} />
                                  <h4 className="mb-3">{homeFeed[2].pga1.title}</h4>
                                  <p className="mb-4">{homeFeed[2].pga1.subtitle}</p>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                              <div className="service-item bg-white text-center h-100 p-4 p-xl-5">
                                  <img className="img-fluid mb-4" src={homeFeed[2].pga2.img} alt="" style={{ objectFit: 'cover', maxHeight: 120, minHeight: 120 }} />
                                  <h4 className="mb-3">{homeFeed[2].pga2.title}</h4>
                                  <p className="mb-4">{homeFeed[2].pga2.subtitle}</p>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                              <div className="service-item bg-white text-center h-100 p-4 p-xl-5">
                                  <img className="img-fluid mb-4" src={homeFeed[2].pga3.img} alt="" style={{ objectFit: 'cover', maxHeight: 120, minHeight: 120 }} />
                                  <h4 className="mb-3">{homeFeed[2].pga3.title}</h4>
                                  <p className="mb-4">{homeFeed[2].pga3.subtitle}</p>
                              </div>
                            </div>
                          </div>
                      </div>

                        <button onClick={async () => {
                          setAboutModalScreen('campaigns')
                          setBannerContent(homeFeed[3])
                        }} data-toggle="modal" data-target="#homeModal" style={{ backgroundColor: "#832a84" }} className="d-inline-block rounded  mt-3 text-white border-0 py-1 px-3 mb-3">Edit Campaigns section</button>
                       
                      <div className='border rounded p-3 mb-3'>
                      <div className="row g-4 justify-content-center">
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                          <div className="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100">
                            <div className="text-center p-4 pt-0">
                              <div className="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4">
                                  <small>{homeFeed[3].pga1.category}</small>
                              </div>
                                <h5 className="mb-3">{homeFeed[3].pga1.title}</h5>
                                <p>{homeFeed[3].pga1.subtitle}</p>

                            </div>
                            <div className="position-relative mt-auto">
                                <img className="img-fluid" src={JSON.parse(homeFeed[3].pga1.imgs).img1} alt="" />

                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                          <div className="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100">
                            <div className="text-center p-4 pt-0">
                              <div className="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4">
                                  <small>{homeFeed[3].pga2.category}</small>
                              </div>
                                <h5 className="mb-3">{homeFeed[3].pga2.title}</h5>
                                <p>{homeFeed[3].pga2.subtitle}</p>

                            </div>
                            <div className="position-relative mt-auto">
                                <img className="img-fluid" src={JSON.parse(homeFeed[3].pga2.imgs).img1} alt="" />

                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                          <div className="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100">
                            <div className="text-center p-4 pt-0">
                              <div className="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4">
                                  <small>{homeFeed[3].pga3.category}</small>
                              </div>
                                <h5 className="mb-3">{homeFeed[3].pga3.title}</h5>
                                <p>{homeFeed[3].pga3.subtitle}</p>

                            </div>
                            <div className="position-relative mt-auto">
                                <img className="img-fluid" src={JSON.parse(homeFeed[3].pga3.imgs).img1} alt="" />

                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      
                    </>
                  )}
                  {id === 'about' && (
                    <div className="col-lg-8 wow fadeIn" data-wow-delay="0.1s">
                      <figure className="mb-5">
                        <img className="img-fluid rounded" style={{ maxHeight: 400 }} src={aboutImg} alt="..." />
                        <button onClick={() => {
                          setAboutModalScreen('headerimg')
                          setAboutModalData(aboutImg)
                        }} data-toggle="modal" data-target="#aboutModal" className="btn btn-primary btn-circle">
                          <i className="fas fa-edit"></i>
                        </button>
                        Edit header Image
                      </figure>
                      <h1 className="display-6 mb-5">{aboutFeed.title}</h1>
                      <button onClick={() => {
                        setAboutModalScreen('aboutcontent')
                        setAboutModalData(aboutFeed)
                      }} data-toggle="modal" data-target="#aboutModal" className="btn btn-primary btn-circle">
                        <i className="fas fa-edit"></i>
                      </button>
                      Edit About Us Content
                      {aboutFeed?.data?.map((item, index) => {
                        // const imgs = JSON.parse(item.imgs)
                        return (
                          <div key={index}>
                            {item.titleVisible && (
                              <h4 class="display-7 mb-2">{item.title}</h4>
                            )}
                            <p class="mb-3">{item.paragraph}</p>
                          </div>
                        )
                      }
                      )}

                      {/* <h4 className="display-7 mb-2">Strategic Objectives</h4>
                            <button onClick={() => {
                              setAboutModalScreen('strategicobjectives')
                              setAboutModalData(aboutFeed)
                            }} data-toggle="modal" data-target="#aboutModal" className="btn btn-primary btn-circle">
                              <i className="fas fa-edit"></i>
                            </button>
                            Edit Strategic Objectives
                            <ol className="list-group list-group-numbered mb-3">
                              <li className="list-group-item">
                                <p className="mb-3">Prevent Sexual & Gender-based-violence, Human Trafficking in person, FGM and Modern Day & Sex Slavery through Lobby, Advocacy, and awareness raising among at risk groups (women and children)</p>
                                <p>- Increased prioritization of issues on Sexual/GBV, human trafficking, FGM and modern day slavery by state and non-state actors</p>
                                <p>- Increased awareness about Sexual/GBV, human trafficking, FGM, and modern day slavery by at risk target groups (women and children).</p>
                              </li>
                              <li className="list-group-item">
                                <p className="mb-3">Promote access to affordable education among vulnerable children living with women survivors of gender based violence, human trafficking, and modern day slavery through support of co-curricular activity and provision of scholastics and tuition</p>
                                <p>- Increased access to affordable education among children living with women survivors of gender based violence, human trafficking, and modern day slavery</p>
                              </li>
                              <li className="list-group-item">
                                <p className="mb-3">Promote women empowerment through entrepreneurship skills among women survivors of gender based violence, human trafficking and modern day slavery through training</p>
                                <p>- Women survivors of gender based violence, human trafficking and modern day slavery skilled on entrepreneurship</p>
                              </li>
                              <li className="list-group-item">
                                <p className="mb-3">Promotes access to affordable health care services among women survivor of gender based violence, human trafficking and modern day slavery and children under their care</p>
                                <p>- Increased access to health care services among women survivors of gender based violence, human trafficking, and modern day slavery and children under their care</p>
                              </li>
                              <li className="list-group-item">
                                <p className="mb-3"> Promote food security among women survivors of gender based violence, human trafficking and modern day slavery through crop husbandry</p>
                                <p>- Increased participation in crop husbandry among women survivors of gender based violence, human trafficking, and modern day slavery</p>
                              </li>
                              <li className="list-group-item">
                                <p className="mb-3">Strengthen RHF organizational and personnel capacity to effectively and efficiently implement her programmes and accountability</p>
                                <p>- Increased effectiveness and efficiency of RHF</p>
                              </li>
                            </ol>
                            <h4 className="display-7 mb-2">Key Achievements</h4>
                            <button onClick={() => {
                              setAboutModalScreen('keyachievements')
                              setAboutModalData(aboutFeed)
                            }} data-toggle="modal" data-target="#aboutModal" className="btn btn-primary btn-circle">
                              <i className="fas fa-edit"></i>
                            </button>
                            Edit Key Achievements
                            <ul>
                              <li className="mb-2">From 2010 to 2012 we established a Community Primary School for children aged 4yrs to 14yrs, currently the school has a total enrolment of 420 Orphans and Vulnerable Children and employing 17 teaching staff members and 8 non-teaching staff members. The school is managed independently but RHF maintains an “eyes on, hands off” relationship with the school’s management to ensure effectiveness and efficiency.</li>
                              <li className="mb-2">We also built a Rural Shelter & Children’s Center between 2010-2012 for victims of Gender Based Violence, Harmful Cultural Practices like FGM, Human Trafficking and Modern Slavery. This Shelter has a capacity of 20 Clients at any one moment and can house clients up to one month.</li>
                              <li className="mb-2">In 2013, we established model farm in Kamuli on a 36 acre piece of land. This farm was initially established to produce food supplies for the GBV Center, Children’s Center and Kamuli Community School, but we quickly realized that it can easily become self-sustaining if we also started Crop & Animal-Husbandry Agriculture School at this farm. This farming School is now training locals in modern farming methods, pest control, harvest management and value addition. Since it’s opening, it has trained over 2,000 households and employees 10 staff members. It’s also offering extension services to the local peasants within the district of Kamuli, Buyende and Luuka. The success of this farming project informed and we learned that there is need to go into agro-forestry farming, so in Dec/2013 we acquired 800 acres of land in Kamuli and we started tree farming, we started by planting 2,000,000 trees of different spices. The main target here is mainly to protect the environment while attracting an income to sustain our different projects. We have also introduced vegetable and fruit trees on this establishment while the community has also gotten involved. Last year we introduced Bee-farming in this project and fish-farming is already under way. This project has been a cash-cow for Rape Hurts Foundation while different schools from all over Eastern Uganda come for study and research and at the same time, it has created food security for well over 2,000 households in the last 6years. This project is also paying School fees and providing scholastic materials to all the 420 Orphans and Vulnerable Children we have at Kamuli Community School. Currently Incomes from this project is also paying school fees for 180 other Children in High Schools (Rape Hurts Foundation sponsors children who graduate from our school to continue with their education in different high schools in Uganda), it’s also paying Tuition fees for 75 University & College Students who have passed through the hands of Rape Hurts Foundation, these are students who will be graduating with degrees and diplomas in different fields and some are already returning to their respective villages to create change. This project has enjoyed a lot from support locally and internationally and in 2016 we made a replica of the same in Butema – Kiryowa Village Buikwe District where Rape Hurts Foundation is established a modern GBV Center. It’s still under this program where we have provided 500,000 solar lights to households, so that they can stop using oil lamps which causes several diseases to humans while affecting the environment.</li>
                              <li className="mb-2">In 2014 we started working on building a Vocational & Life Skills Training Center in Kamuli. Initially we started with training in Tailoring/Sewing/Knitting and Carpentry. Currently total enrollment for Tailoring department is standing at 120 Women aged 15yrs to 30yrs (most these are single mothers, teenager mothers and widows), while carpentry has 85 mainly boys and young men, aged 15yrs to 35yrs. The concept of involving boys and men in this project was to engage them and how they can help us in fighting gender based violence. We have learned that an employed and skilled young man is less likely to involve himself in gender based violence.</li>
                              <li className="mb-2">In 2015 we established a Welding & Metal Fabrication Workshop and training center which has a total enrolment of 35 youths. The idea of the welding & metal fabrication suffered some challenges at the on-site because we didn’t have grid-power in our Village, so we had to establish it in Jinja, 60Km away from our Vocational & Life Skills Training Center. However the hustle was worth it, we quickly started making some good income from the selling of fabricated windows, doors, household items, security doors/gates etc. while training young men and women in this trade. The profits from this project go towards the administrative expenses of Rape Hurts Foundation. With support from Transpetrol Foundation, we have expanded this Vocational & Life Skills Training Project to incorporate Bakery, Brick laying and wall construction, Motorcycle and Bicycle Mechanics onto our training course program. We have built permanent structures and hired more professional staff members. This project employs 15 workers in total.  We have dreams of putting up an ICT Training Center at this project site to complement on the achievements of this Vocational & Life Skills Training Center.</li>
                              <li className="mb-2">Earlier on in 2016 we started the making of art & crafts, this includes paper beads/jewelry making of table mats, door mats, rags, house decorations etc. These are all selling items and this department of art and craft has an enrolment of 65 women and girls and employs a group of 18 women. It’s through these self-empowerment projects, that Rape Hurts Foundation officially opened the RHF – Micro-Finance Group, which has 720 Members. Through this arrangement, members save, get group loans, learn more on local investing and hence we are already seeing a change in their incomes.</li>
                              <li className="mb-2">It might sound strange to some, but somehow if you live in our villages, you can’t separate access to safe clean water and Sexual Gender Based Violence. Hundreds of Thousands of women are raped annually, as the walk miles to go and fetch water from swamps and valleys, yet some are even beaten and threatened by their husbands when they delay to return home from the wells. It’s a complicated thing here!!! In 2012 Rape Hurts Foundation started on a WASH project. This involved protecting water wells, drilling boreholes while training women in the making of Bio Sand Water filters. Since this is more of a social enterprise project, apart from its charity merits, it has created jobs for 1,800 women who are making and selling Bio Sand water filters all over Eastern Uganda. These are women who have now improved on their household incomes while creating access to safe clean water for hundreds of thousands of people in this sub region. In 2015 we started Soap making and this has also created many jobs while providing locals with affordable liquid soap. RHF staff developed training manuals for WASH and use it as a guideline for community sensitization programs to raise awareness about the importance of homestead and personal hygiene as ways of reducing spread of diseases. Since 2016 we carried out 50 Community training about sanitation and hygiene reaching out to over 20,000 people.</li>
                              <li className="mb-2">Since we opened our doors in 2008, Rape Hurts Foundation has provided GBV Emergency Response to 850,000 Women and Children. We have responded from small cases to very big cases involving big families. We have also responded to 1,500 cases of Female Genital Mutilation and other harmful cultural practices and with the support of Vital Voices the numbers for victims we attending to, are doubling. We have rescued 620 girls from sex slavery and other forms of modern day slavery in the 11 years. Through our lobbying and advocacy projects we have caused the parliament to respond to the cases of hundreds of thousands of Ugandan (especially women) who are trafficked to Middle East and around the world. Even the Uganda Police established a special Office which handles causes of Human Trafficking and Child Sacrifice. With the support of GIZ and Thompson Reuters, I represented RHF in the trainings with Global Leadership Academy about unveiling Trafficking In Person (TIP) and also have attended the Trust Law Conferences for the past two years. We have campaigned against Human Child Sacrifice – Murder for ritual purposes and we have seen the number of ritual child murders drop since 2015. This program runs in all the 16 districts which make Eastern Uganda. We run weekly talk shows on both radio and local Televisions.</li>
                              <li className="mb-2">Under Health & Care Program, we have partnered with different stakeholders to provide TB/HIV/AIDS drugs to 2,000 Women and Children living with HIV/AIDS. At the same time we provide free condoms, carry our awareness campaigns, Mobile free HIV testing and on-going counseling. We have also distributed treated mosquito nets to 5,000 households in the last 11 years. Under the reproductive health projects, we have embarked on promoting menstrual hygiene through which we have distributed re-usable and non-reusable pads to 780 underprivileged school girls and we have also trained 200 rural women to make re-usable sanitary pads for their family members that last for a period of one year.</li>
                              <li className="mb-2">Legal Aid & Pro Bono services, Rape Hurts Foundation has been at the forefront to support victims and services of Gender Based Violence, Human Trafficking, Modern Day Slavery and Harmful practices to access legal help and get justice. We have worked with 16 law firms such as Bowmans (MP Mpanga & Co. Advocates), Taslaf & Co. Advocates and Onyango & company advocates etc and other supportive partners like Thomson Reuters Foundation provide legal help to over 850,000 Women & Children in the last 11 years. We have also developed internal working documents, guidelines, procedures and policy to help us professionalize our work. It’s through this work that I received an Impact Award 2018 from Trust Law Thomson Reuters in NY USA. In 2018 I was also nominated for the award of African Female Leader by The Global Thinkers Forum London UK, and am currently a mentor with the same Organization.</li>
                              <li className="mb-2">We are finishing the construction of our Modern GBV Shelter with a capacity of 80 clients in Butema/Kiryowa Village Buikwe, we have also started on the construction of Tammy Morrison Women & Children’s Hospital in Musima Village Jinja, the 1st of its kind in Eastern Uganda, specifically serving the needs of marginalized, survivors and victims of GBV, Human Trafficking, Harmful culture practices and modern day slavery.</li>
                              <li className="mb-2">Establishment of the Solar Powered Water Supply System for Bukyerimba Village, a project directly impacting over 500 households, by the 2021, the water coverage in Bukyerimba Village will be at 100%</li>
                              <li className="mb-2">In a bid to fight crime, RHF has installed and mounted solar powered street lights in Bukyerimba Village; this has come in to increase the number of working hours, hence increasing productivity.</li>
                              <li className="mb-2">Rape Hurts Foundation is building the fast of its kind Women & Children’s hospital.
                                Rape Hurts Foundation projects are designed and implemented following a holistic/integrated approach that focuses on the physical and psychological needs of women in their totally while paying attention to how their social, political, cultural, economic surroundings influence their wellbeing. RHF strives to ensure all interventions are geared towards sustainability, the long term. Rape Hurts Foundation is a growing and learning organization open to ideas, suggestions, criticisms, technical support and guidance so that we can move towards total self-reliance and be able to serve our clients even much more better.</li>
                            </ul>
                            <h4 className="display-7 mb-2">Our Core Values</h4>
                            <button onClick={() => {
                              setAboutModalScreen('corevalues')
                              setAboutModalData(aboutFeed)
                            }} data-toggle="modal" data-target="#aboutModal" className="btn btn-primary btn-circle">
                              <i className="fas fa-edit"></i>
                            </button>
                            Edit Core Values
                            <ul className="list-inline">
                              <li className="list-inline-item">Transparency</li>
                              <li className="list-inline-item">Participation</li>
                              <li className="list-inline-item">Inclusivity</li>
                              <li className="list-inline-item">Accountability</li>
                              <li className="list-inline-item">Team work</li>
                            </ul> */}
                      {/* <h4 className="display-7 mb-2">Our Partners</h4> */}

                    </div>
                  )}
                  {id === 'hellen' && (
                    <></>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <HomeModal screen={aboutModalScreen} data={bannerContent} handleBannerDataAdd={handleBannerDataAdd} handleBannerImgChange={handleBannerImgChange} handleBannerDataDelete={handleBannerDataDelete} onChangeCaption={onChangeCaption} onChangeBannerTitle={onChangeBannerTitle} setHomeData={setHomeData} />
      <AboutModal screen={aboutModalScreen} data={aboutModalData} setAboutData={setAboutData} />
    </div>
  )
}

export default WebsiteContent
